import { createContext } from "react";

export const ProvinciasContext = createContext()
export const ProvinciasFormContext = createContext()
export const ProvinciasReportContext = createContext()